import primaryButton from '../../../../primary-button';

const dark = (params) => primaryButton.solidIcon.background.disabled.dark(params);

export default dark;
